import { clsx } from 'clsx';
import styles from './ui.module.css';

/**
 * Ряд разделов — что показываем: другой список под той же шапкой.
 *
 * Текст с подчёркиванием, ряд на экране один и стоит первым под шапкой.
 * Фильтр — «чем сужаем тот же список» — это не он, а `FilterSelect` под
 * поиском (решение владельца 28.09.2026).
 *
 * Счётчик — отдельный значок, а не дописанное в подпись «· 3»: вклеенный в
 * строку, он обрезался вместе с ней («Способности · 2» не влезает в 375 px).
 *
 * Выбранная подпись жирнее, но места не прибавляет: `data-label` отдаёт её
 * невидимой копии в жирном начертании, и ширину подпись берёт по ней всегда.
 * Иначе выбранная вкладка раздувалась, а соседи съезжали вбок.
 */

export interface TabRowOption<T extends string> {
  value: T;
  label: string;
  /** null = счётчик этой роли не виден (очередь не её), 0 показываем честно. */
  count?: number | null;
}

export function TabRow<T extends string>({
  value,
  options,
  onChange,
  disabled,
}: {
  value: T;
  options: readonly TabRowOption<T>[];
  onChange: (value: T) => void;
  disabled?: boolean;
}) {
  return (
    <div className={clsx(styles.filterRow, styles.tabRow, styles.tabRowUnderline)}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={clsx(styles.tabUnderline, option.value === value && styles.tabUnderlineActive)}
          aria-pressed={option.value === value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          <span className={styles.tabLabel} data-label={option.label}>
            {option.label}
          </span>
          {option.count === undefined || option.count === null ? null : (
            <span className={styles.tabCount}>{option.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
